<template>
  <div :style="cardStyle">
      <header :style="headerStyle" v-if="hasHeader">
          <slot name="header"></slot>
      </header>
      <main :style="mainStyle">
          <slot ></slot>
      </main>
      <footer :style="footerStyle" v-if="hasfooter">
          <slot name="footer"></slot>
      </footer>
  </div>
</template>

<script>
    export default {
        props : {
            width : { type : Number, default :null },
            height : { type : Number, default :null },
            padding : { type : Object, default : () => ({x : 1, y : 1})},
            margin : { type : String, default : null },
            bordered : { type : Boolean, default : true},
            border : { type : Object, default : () => ({ width : .2, color : '#EDEDED', style : 'solid'})},
            backgroundColor : { type  :String, default : '#ffffff'},
            color : { type  :String, default : '#333'},
            rounded : { type : Number, default : .5},
            boxShadow : { type : Object, default: ()=>({})},
            hasHeader : { type : Boolean, default : true},
            hasfooter : { type : Boolean, default : true},
            header : { type : Object, default : () => ({ 
                padding : { x : 0.5, y : .5 },
                backgroundColor : '#ffffff',
                color : '#333',
                border : null,
                pointer : false
             })},
            main : {type : Object, default : () => ({ 
                padding : { x : 0.5, y : .5 },
                backgroundColor : '#ffffff',
                color : '#333',
                border : null,
                rounded : { type : Number, default : .5},
             })},
            footer : {type : Object, default : () => ({ 
                padding : { x : 0.5, y : .5 },
                backgroundColor : '#ffffff',
                color : '#333',
                border : null
             })}
        },
        computed : {
            cardStyle(){
                return {
                    width : this.width ? this.width+'rem' : '100%',
                    height : this.height ? this.height+'rem' : 'auto',
                    padding : `${this.padding.y}rem ${this.padding.x}rem`,
                    margin : this.margin ? this.margin : 0,
                    border : this.bordered ? `${this.border.width}rem ${this.border.style} ${this.border.color}` : 'none',
                    backgroundColor : this.backgroundColor,
                    color : this.color,
                    'border-radius' : this.rounded ? this.rounded+'rem' : 0,
                    'box-shadow' : this.boxShadow ? `${this.boxShadow.x}px ${this.boxShadow.x}px ${this.boxShadow.blur}px ${this.boxShadow.color}` : 'none',
                }
            },
            headerStyle(){
                return {
                    padding : `${this.header.padding.y}rem ${this.header.padding.x}rem`,
                    border : this.header.border ?`${this.header.border.width}rem ${this.header.border.style} ${this.header.border.color}` : 'none',
                    backgroundColor : this.header.backgroundColor,
                    color : this.header.color,
                    'border-radius' : this.rounded ? this.rounded+'rem' : 0,
                    // cursor : this.header.pointer ? 'pointer': none ,
        
                }
            },
            mainStyle(){
                return {
                    padding : `${this.main.padding.y}rem ${this.main.padding.x}rem`,
                    border : this.main.border ?`${this.main.border.width}rem ${this.main.border.style} ${this.main.border.color}` : 'none',
                    backgroundColor : this.main.backgroundColor,
                    color : this.main.color,
                    'border-radius' : this.rounded ? this.rounded+'rem' : 0,
                    height : '100%'
                }
            },
            footerStyle(){
                return {
                    padding : `${this.footer.padding.y}rem ${this.footer.padding.x}rem`,
                    border : this.footer.border ?`${this.footer.border.width}rem ${this.footer.border.style} ${this.footer.border.color}` : 'none',
                    backgroundColor : this.footer.backgroundColor,
                    color : this.footer.color,
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/global/Card.vue